import(/* webpackMode: "eager" */ "/workspace/apps/home-webapp/src/app/(home)/@banner/page.tsx");
